// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetOrganisationForUserRequestModel from '../../model/get-organisation-for-user-request-model';
import GetOrganisationForUserRequestDTO from '../dto/get-organisation-for-user-request-dto';
import dtoSchema from '../schemas/get-organisation-for-user-request-schema';

export default abstract class GetOrganisationForUserRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetOrganisationForUserRequestDTO>) {
    super();
  }

  static toModel(dto: DeepPartial<GetOrganisationForUserRequestDTO>): GetOrganisationForUserRequestModel;
  static toModel(dto: DeepPartial<GetOrganisationForUserRequestDTO> | undefined | null): GetOrganisationForUserRequestModel | undefined;
  static toModel(dto: DeepPartial<GetOrganisationForUserRequestDTO> | undefined | null): GetOrganisationForUserRequestModel | undefined {
    return dto ? new GetOrganisationForUserRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetOrganisationForUserRequestModel> | GetOrganisationForUserRequestModel): GetOrganisationForUserRequestDTO {
    const dto = {
    } as GetOrganisationForUserRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetOrganisationForUserRequestModel, can not map to GetOrganisationForUserRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
